// 路由的页面模块路径描述
const routeDesc = {
  '/home': '首页',
  '/lucky/list': '全友活动/幸运星球'
};

const routeDescMap = {};
for (const [key, value] of Object.entries(routeDesc)) {
  routeDescMap[key] = encodeURIComponent(value);
}

export default routeDescMap;